import type * as L from 'leaflet';
import { MapControl } from '../interface';

/**
 * First marker custom icon options
 */
export const FIRST_MARKER_ICON_OPTIONS: L.DivIconOptions = {
    html: `<div id="first-marker" class="h-[18px] w-[18px] rounded-full bg-red-500 group relative">
    <span class="group-hover:opacity-100 opacity-0 translate-all pointer-events-none duration-150 absolute -top-[30px] -left-[80px]  bg-white rounded-md p-1.5 text-xs font-medium w-fit text-nowrap">Click here to complete the territory</span></div>`,
    iconSize: [18, 18],
    className: '',
    iconAnchor: [9, 9],
    popupAnchor: [0, -18],
};

/**
 * The rest of the marker icons options
 */
export const DEFAULT_MARKER_ICON_OPTIONS: L.DivIconOptions = {
    html: `<div class="h-4 w-4 rounded-full bg-white border-[1.5px] border-accent-500"></div>`,
    iconSize: [15, 15],
    className: '',
    iconAnchor: [7, 7],
    popupAnchor: [0, -15],
};

/**
 * Custom map controls
 */
export const MAP_CONTROLS: MapControl[] = [
    { id: 'view-btn', icon: 'paper-plane', tooltip: 'View' },
    { id: 'draw-btn', icon: 'pencil-edit', tooltip: 'Draw' },
    { id: 'delete-btn', icon: 'outline-trash', tooltip: 'Delete mapped points' },
    { id: 'upload-btn', icon: 'upload', tooltip: 'Upload' },
    { id: 'undo-btn', icon: 'undo', tooltip: 'Undo' },
    { id: 'redo-btn', icon: 'redo', tooltip: 'Redo' },
];

/**
 * Warning message for create user. This is fed in the input signal
 */
export const CREATE_USER_WARNING_MESSAGE =
    "The area you've just drawn overlaps with an existing territory owned by another user. Establishing a business or assigning operations within its overlapping area may lead to ownership or operational conflits. Please review and adjust your territory boundaries to avoid potential disputes or financial loss.";
